export default [{
    path: '/corporation/',
    name: 'corporation-index',
    component: () => import('@/router/tmp/corporation/index.vue'),
    children: [
      {
        path: '/corporation/automatic',
        name: 'corporation-automatic',
        component: () => import('@/router/tmp/corporation/automatic-viewing.vue')
      },{
        path: '/corporation/custom',
        name: 'corporation-custom',
        component: () => import('@/router/tmp/corporation/custom.vue')
      },{
        path: '/corporation/management',
        name: 'corporation-management',
        component: () => import('@/router/tmp/corporation/management.vue')
      },{
        path: '/corporation/myAccount',
        name: 'corporation-mine',
        component: () => import('@/router/tmp/corporation/mine.vue')
      },{
        path: '/corporation/notification',
        name: 'corporation-notic',
        component: () => import('@/router/tmp/corporation/notic.vue')
      }
    ]
  },{
    path: '/imagingEngineer/',
    name: 'imagingEngineer-index',
    component: () => import('@/router/tmp/imagingEngineer/index.vue'),
    children: [{
        path: '/imagingEngineer/custom',
        name: 'imagingEngineer-custom',
        component: () => import('@/router/tmp/imagingEngineer/custom.vue')
      },{
        path: '/imagingEngineer/management',
        name: 'imagingEngineer-management',
        component: () => import('@/router/tmp/imagingEngineer/management.vue')
      },{
        path: '/imagingEngineer/myAccount',
        name: 'imagingEngineer-mine',
        component: () => import('@/router/tmp/imagingEngineer/mine.vue')
      },{
        path: '/imagingEngineer/notification',
        name: 'imagingEngineer-notic',
        component: () => import('@/router/tmp/imagingEngineer/notic.vue')
      }
    ]
  },{
    path: '/physician/',
    name: 'physician-index',
    component: () => import('@/router/tmp/physician/index.vue'),
    children: [
      {
        path: '/physician/automatic',
        name: 'physician-automatic',
        component: () => import('@/router/tmp/physician/automatic-viewing.vue')
      },{
        path: '/physician/custom',
        name: 'physician-custom',
        component: () => import('@/router/tmp/physician/custom.vue')
      },{
        path: '/physician/management',
        name: 'physician-management',
        component: () => import('@/router/tmp/physician/management.vue')
      },{
        path: '/physician/myAccount',
        name: 'physician-mine',
        component: () => import('@/router/tmp/physician/mine.vue')
      },{
        path: '/physician/notification',
        name: 'physician-notic',
        component: () => import('@/router/tmp/physician/notic.vue')
      }
    ]
  },{
    path: '/salesRep/',
    name: 'salesRep-index',
    component: () => import('@/router/tmp/salesRep/index.vue'),
    children: [
      {
        path: '/salesRep/automatic',
        name: 'salesRep-automatic',
        component: () => import('@/router/tmp/salesRep/automatic-viewing.vue')
      },{
        path: '/salesRep/custom',
        name: 'salesRep-custom',
        component: () => import('@/router/tmp/salesRep/custom.vue')
      },{
        path: '/salesRep/management',
        name: 'salesRep-management',
        component: () => import('@/router/tmp/salesRep/management.vue')
      },{
        path: '/salesRep/myAccount',
        name: 'salesRep-mine',
        component: () => import('@/router/tmp/salesRep/mine.vue')
      },{
        path: '/salesRep/notification',
        name: 'salesRep-notic',
        component: () => import('@/router/tmp/salesRep/notic.vue')
      }
    ]
  },{
    path: '/login',
    name: 'login',
    component: () => import('@/router/tmp/login/login.vue'),
  },{
  path: '/',
  name: 'login',
  component: () => import('@/router/tmp/login/login.vue'),
}
]
